function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable react/no-danger */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { WDHComponent, onResize } from '../../../../../../wdh-foundation/wdh';
import { SiteCoreEditFrame, SiteCoreLink } from '../../../../js/project/sitecore-content-parser';
var ImageSpot = /*#__PURE__*/function (_React$Component) {
  function ImageSpot(props) {
    var _this;
    _classCallCheck(this, ImageSpot);
    _this = _callSuper(this, ImageSpot, [props]);
    _this.state = {};
    return _this;
  }

  // eslint-disable-next-line camelcase
  _inherits(ImageSpot, _React$Component);
  return _createClass(ImageSpot, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      onResize(function () {}); // TODO. Handle window resizing
    }
  }, {
    key: "hasEmbeddedContent",
    value: function hasEmbeddedContent(linkTag) {
      if (linkTag) {
        var title = linkTag.title;
        return title && title.indexOf('iframe') !== -1;
      }
      return false;
    }
  }, {
    key: "renderImage",
    value: function renderImage(index) {
      var _this$props = this.props,
        elements = _this$props.elements,
        wrapImageWithLink = _this$props.wrapImageWithLink;
      var img = elements[index].querySelector('.image-spot-element-image');
      if (img === null) return null;
      var link = elements[index].querySelector('.image-spot-element-link a');
      if (link && wrapImageWithLink) {
        return /*#__PURE__*/React.createElement(SiteCoreLink, {
          htmlAnchorElement: link
        }, /*#__PURE__*/React.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: img.innerHTML
          }
        }), this.hasEmbeddedContent(link) && /*#__PURE__*/React.createElement("div", {
          className: "play-button-container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "like-button-minimal"
        }, "play_arrow")));
      }
      return /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: img.innerHTML
        }
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader(index) {
      var elements = this.props.elements;
      var header = elements[index].querySelector('.image-spot-element-header');
      return /*#__PURE__*/React.createElement(React.Fragment, null, header && header.textContent !== '' && /*#__PURE__*/React.createElement("div", {
        className: "image-spot-element-header",
        dangerouslySetInnerHTML: {
          __html: header.innerHTML
        }
      }));
    }
  }, {
    key: "renderText",
    value: function renderText(index) {
      var elements = this.props.elements;
      var text = elements[index].querySelector('.image-spot-element-text');
      return /*#__PURE__*/React.createElement(React.Fragment, null, text && text.innerHTML !== '' && /*#__PURE__*/React.createElement("div", {
        className: "image-spot-element-text",
        dangerouslySetInnerHTML: {
          __html: text.innerHTML
        }
      }));
    }
  }, {
    key: "renderLink",
    value: function renderLink(index) {
      var _this$props2 = this.props,
        elements = _this$props2.elements,
        linkClasses = _this$props2.linkClasses;
      var link = elements[index].querySelector('.image-spot-element-link a');
      return /*#__PURE__*/React.createElement(React.Fragment, null, link && /*#__PURE__*/React.createElement("div", {
        className: "image-spot-element-link"
      }, /*#__PURE__*/React.createElement(SiteCoreLink, {
        htmlAnchorElement: link,
        additionalClasses: linkClasses
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var elements = this.props.elements;
      return /*#__PURE__*/React.createElement(React.Fragment, null, elements.map(function (element, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "image-spot-element",
          key: "image-element-".concat(index)
        }, /*#__PURE__*/React.createElement(SiteCoreEditFrame, {
          element: elements[index]
        }, /*#__PURE__*/React.createElement("div", {
          className: "image-spot-element-image"
        }, _this2.renderImage(index)), _this2.renderHeader(index), _this2.renderText(index), _this2.renderLink(index)));
      }));
    }
  }]);
}(React.Component);
ImageSpot.propTypes = {
  elements: PropTypes.arrayOf(PropTypes.instanceOf(HTMLLIElement)).isRequired,
  linkClasses: PropTypes.arrayOf(PropTypes.string).isRequired,
  wrapImageWithLink: PropTypes.bool.isRequired
};

/**
 * @memberOf module:wdh-image-spot
 */
var WDHImageSpot = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function WDHImageSpot() {
    var _this3;
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'image-spot';
    _classCallCheck(this, WDHImageSpot);
    _this3 = _callSuper(this, WDHImageSpot, [className]);

    // Public interface
    /**
     * Wraps the image with the link of the element, if there is any
     * @type {boolean}
     * @default false
     */
    _this3.wrapImageWithLink = false;
    _this3.reactApp = ImageSpot;
    _this3.linkClasses = [];
    return _this3;
  }
  _inherits(WDHImageSpot, _WDHComponent);
  return _createClass(WDHImageSpot, [{
    key: "init",
    value: function init(component) {
      var elements = Array.prototype.slice.call(component.querySelectorAll('.image-spot-element'));
      ReactDOM.render(/*#__PURE__*/React.createElement(this.reactApp, {
        elements: elements,
        wrapImageWithLink: this.wrapImageWithLink,
        component: component,
        linkClasses: this.linkClasses
      }), component.querySelector('.component-content'));
    }
  }]);
}(WDHComponent);
export default WDHImageSpot;